import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { displayMoney } from "../helpers/utils";
import cartContext from "../contexts/cart/cartContext";
// import productsData from '../data/productsData';
import commonContext from "../contexts/common/commonContext";

const ProductDetails = () => {
  const { addItem } = useContext(cartContext);
  const { productsData } = useContext(commonContext);

  const { productId } = useParams();
  const prodId = parseInt(productId);
  const navigate = useNavigate();

  const product = productsData.find((item) => item.id === prodId);
  const { image, title, description, price } = product;
  const [previewImg, setPreviewImg] = useState(image);
  const [added, setAdded] = useState(false);

  useEffect(() => {
    setPreviewImg(image);
  }, [image]);

  const handleAddItem = () => {
    addItem(product);
    setAdded(true);
    setTimeout(() => {
      navigate("/cart");
    }, 1000);
  };

  const newPrice = displayMoney(price);
  const oldPrice = displayMoney(0);

  return (
    <>
      <section id="product_details" className="section">
        <div className="container">
          <div className="wrapper prod_details_wrapper">
            <div className="prod_details_left_col">
              <figure className="prod_details_img">
                <img src={previewImg} alt="product-img" />
              </figure>
            </div>

            <div className="prod_details_right_col">
              <h1 className="prod_details_title">{title}</h1>
              <h4 className="prod_details_info">{description}</h4>
              <div className="prod_details_price">
                <div className="price_box">
                  <h2 className="price">
                    {newPrice} &nbsp;
                    <small className="del_price">
                      {/* <del>{oldPrice}</del> */}
                    </small>
                  </h2>
                </div>
              </div>
              {/* <div className="prod_details_description">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
              </div> */}
              <div className="prod_details_buy_btn">
                <button
                  type="button"
                  className={`btn ${added ? "added" : ""}`}
                  onClick={handleAddItem}
                >
                  {added ? "Dodano" : "Dodaj do koszyka"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
